"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBgHexColorCodeProperty = exports.bgHexColorCodePropertyDefinition = void 0;
const BG_HEX_COLOR_CODE_PATTERN = '^#(?:[0-9a-fA-F]{3}){1,2}$';
exports.bgHexColorCodePropertyDefinition = {
    name: 'bg-hex-color-code',
    type: 'text',
    constraints: [
        {
            name: 'pattern',
            argument: BG_HEX_COLOR_CODE_PATTERN,
        },
    ],
    multiple: false,
    view: {
        label: 'Background color',
        hint: 'Color code for the background of the promo UX - in HEX format - e.g. #FFFFFF.',
    },
};
const isBgHexColorCodeProperty = (prop) => {
    return prop.name === exports.bgHexColorCodePropertyDefinition.name;
};
exports.isBgHexColorCodeProperty = isBgHexColorCodeProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmctaGV4LWNvbG9yLWNvZGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9iZy1oZXgtY29sb3ItY29kZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLHlCQUF5QixHQUFHLDRCQUE0QixDQUFBO0FBRWpELFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixJQUFJLEVBQUUsTUFBTTtJQUNaLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUseUJBQXlCO1NBQ3BDO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxrQkFBa0I7UUFDekIsSUFBSSxFQUFFLCtFQUErRTtLQUN0RjtDQUM4QixDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=